import { useEffect, useState } from 'react';
import { sprekersApi } from '../api';
import type { PresentationTemplate } from '../types';

function useTemplateList(select: (templates: PresentationTemplate[]) => PresentationTemplate[]) {
  const [templates, setTemplates] = useState<PresentationTemplate[]>([]);

  useEffect(() => {
    let active = true;
    sprekersApi
      .listTemplates()
      .then((data) => {
        if (active) setTemplates(select(Array.isArray(data) ? data : []));
      })
      .catch(() => {
        if (active) setTemplates([]);
      });
    return () => {
      active = false;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return templates;
}

/** Stijlsjablonen voor de stijlkeuze bij een presentatie (slides-sjablonen bevatten geen stijl). */
export default function useTemplates() {
  return useTemplateList((all) => all.filter((template) => (template.template_type ?? 'style') === 'style'));
}

/** Visuele en bewerkbare sjablonen waaruit een nieuwe presentatie gemaakt kan worden. */
export function useSlidesTemplates() {
  return useTemplateList((all) => all.filter((template) => template.template_type === 'slides' || template.template_type === 'editable'));
}
